module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10264.544f4a23.jpg";